import React, { Component } from 'react';
import { Field, reset } from 'redux-form';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import PBGUserAgreement from '../pbg-user-agreement';
import InputField from '../form-field';
import { formatMessage } from '../../lib/intl';

export const FORM_NAME = 'signupForm';

const i18n = defineMessages({
  fullNameNotPresent: {
    id: 'signupModal.errors.fullName',
    defaultMessage: 'Enter your full name',
  },
  emailNotPresent: {
    id: 'signupModal.errors.email',
    defaultMessage: 'Enter an email',
  },
  passwordNotPresent: {
    id: 'signupModal.errors.passwordNotPresent',
    defaultMessage: 'Enter a password',
  },
  passwordBadLength: {
    id: 'signupModal.errors.passwordBadLength',
    defaultMessage: 'Password must be at least 8 characters',
  },
  passwordFieldLabel: {
    id: 'signupModal.fields.password.label',
    defaultMessage: 'Create password',
  },
  passwordFieldSubtext: {
    id: 'signupModal.fields.password.subtext',
    defaultMessage: 'Password must be at least 8 characters long'
  },
  emailFieldLabel: {
    id: 'signupModal.fields.email.label',
    defaultMessage: 'Email',
  },
  fullNameFieldLabel: {
    id: 'signupModal.fields.fullName.label',
    defaultMessage: 'Full name',
  },
});

class SignupForm extends Component {
  constructor(props) {
    super(props);
    this.formatMessage = formatMessage(this.props.intl);
  }

  get emailSubtext() {
    if (this.props.emailInUse) {
      return (
        <div className="small-print">
          <span className="coral-error">
            <FormattedMessage
              id="signupModal.fields.email.inUseMessage"
              defaultMessage="Email already in use"
            />
          </span>
          {' '}
          <a href="#login" onClick={this.onLoginClick}>
            <FormattedMessage
              id="signupModal.signinLink"
              defaultMessage="Sign in"
            />
          </a>
        </div>
      );
    }
    return '';
  }

  onLoginClick = () => this.props.onLoginClick();

  onSubmit = (values) => {
    return this.props.onSubmit(values);
  }

  onEmailChange = (ev) => {
    return this.props.onEmailChange(ev.target.value);
  }

  render() {
    const { handleSubmit } = this.props;

    if (this.props.clearForm) {
      this.props.dispatch(reset(FORM_NAME));
      this.props.onClearForm();
    }

    return (
      <form onSubmit={handleSubmit(this.onSubmit)}>
        <Field
          name="fullName"
          type="text"
          component={InputField}
          label={this.formatMessage(i18n.fullNameFieldLabel)}
        />
        <Field
          name="email"
          type="email"
          component={InputField}
          onChange={this.onEmailChange}
          subtext={this.emailSubtext}
          label={this.formatMessage(i18n.emailFieldLabel)}
        />
        <Field
          name="password"
          type="password"
          component={InputField}
          label={this.formatMessage(i18n.passwordFieldLabel)}
          subtext={this.formatMessage(i18n.passwordFieldSubtext)}
          disabled={this.props.emailInUse}
        />

        <button type="submit" className="btn btn-primary full-width">
          <FormattedMessage
            id="signupModal.submit.text"
            defaultMessage="Create Account"
          />
        </button>
        <p className="text-center small-print mt-2 w-75 mx-auto">
          <FormattedMessage
            id="signupModal.termsAndConditions.acceptanceText"
            defaultMessage="By signing up, you confirm that you accept the"
          />
          <br />
          <PBGUserAgreement />
        </p>
      </form>
    )
  }
}

export default injectIntl(SignupForm);



// WEBPACK FOOTER //
// ./src/desktop/components/signup-modal/form.js